import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import client from "@/lib/api";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ProductCard } from "@/components/ProductCard";
import { TechnicianBar } from "@/components/TechnicianBar";
import { useStore } from "@/context/StoreContext";
import { Button } from "@/components/ui/button";

const Favourites = () => {
  const { favourites } = useStore();
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!favourites.length) { setItems([]); return; }
    client.post("/products/by-skus", { skus: favourites }).then((r) => setItems(r.data.items));
  }, [favourites.join(",")]);

  return (
    <div className="App min-h-screen flex flex-col bg-white">
      <Navbar />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 w-full py-8 flex-1">
        <h1 className="text-2xl font-bold tracking-tight text-graphite mb-1">Favourite Parts</h1>
        <p className="text-sm text-steel-light mb-6">Your saved parts for quick access.</p>
        {favourites.length === 0 ? (
          <div className="grid place-items-center py-24 text-center">
            <Heart className="w-12 h-12 text-steel-light mb-4" />
            <p className="text-steel font-medium">No favourites yet</p>
            <p className="text-sm text-steel-light mb-4">Tap the heart on any product to save it here.</p>
            <Link to="/catalogue"><Button className="bg-orange hover:bg-orange-hover">Browse Catalogue</Button></Link>
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            {items.map((p) => <ProductCard key={p.sku} product={p} />)}
          </div>
        )}
      </div>
      <Footer />
      <TechnicianBar />
    </div>
  );
};

export default Favourites;
